const TYPE = "historicoPedido";

const historicoPedidoModule = {
  find: async (dbConnection, idProdutoIntegracao, idClienteIntegracao) => {
    let historico = null;
    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        "produto.idIntegracao": { $eq: idProdutoIntegracao },
        "cliente.idIntegracao": { $eq: idClienteIntegracao },
        status: { $eq: "A" },
        statusItem: { $eq: "A" },
      },
      fields: ["dtEmissao", "precoDesc", "qtd", "precoTot", "precoUnit"],
    });

    if (result.docs.length) historico = result.docs[0];

    return historico;
  },
};

export default historicoPedidoModule;
